var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoInfoBox = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "EC86757C-AE41-4687-A4C1-CCE2F86927BB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "29-Think-tank",
    transform: "translate(-332.000000, -64.000000)",
    fill: "#191919",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/24x24/ico_box_i",
    transform: "translate(330.000000, 62.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,22 L2,2 L22,2 L22,22 L2,22 Z M4,20 L20,20 L20,4 L4,4 L4,20 Z M13,17.0005 L11,17.0005 L11,11.0005 L13,11.0005 L13,17.0005 Z M13,9.0005 L11,9.0005 L11,7.0005 L13,7.0005 L13,9.0005 Z",
    id: "shape"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoInfoBox);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_info_box.72819eb9e6dd1ecbfdd2b11c53117ff9.svg";